/* eslint-disable react/no-unescaped-entities */
import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import { UiSpinner, UiStack, UiText, UiVStack, uiStyles } from '@/lib/ui';
import BaseMessageBarInfo from '@/base/MessageBar/Info';
import RegistrationDetails from './RegistrationDetails';
import { type ApiResponseSingle } from '@/api/tenantClient';
import { isError } from '@/lib/util';
import { type Order } from '@/api/registration';
import InfoBox from '@/registration/component/InfoBox';

interface ConfirmationPageProps {
  data: ApiResponseSingle<Order> | undefined
  isLoading: boolean
  fetchError: any
  statusToCheck: string[]
  confirmationMetadata?: {
    title?: string
    message?: string
  }
}

const ConfirmationPage: FC<ConfirmationPageProps> = ({ data, isLoading, fetchError, statusToCheck, confirmationMetadata }) => {
  const isMatchStatusToCheck = statusToCheck.includes(data?.item?.status ?? '');
  const hasError = isError(data?.errors) || fetchError;
  if (isLoading) {
    return (
      <RegisterLayout showShoppingCart={false}>
        <UiVStack spacing={4}>
          <UiSpinner />
          <UiText variant={'h6'}>We're completing your order, please wait</UiText>
        </UiVStack>
      </RegisterLayout>
    );
  }

  return (
    <RegisterLayout showShoppingCart={false}>
      <BaseTransitionSlideLeft>
        <UiStack flexGrow={1} spacing={8}>
          <UiStack>
            {hasError && <UiText variant={'h6'}>Registration failed</UiText>}
            {isMatchStatusToCheck && (
              <InfoBox
                title={confirmationMetadata?.title || 'Registration successful'}
              />
            )}
          </UiStack>
          {hasError && (
            <BaseMessageBarInfo borderRadius={uiStyles.borderRadius} bgColor={'red.100'}>
              Something went wrong, please try again later
            </BaseMessageBarInfo>)}
          {(isMatchStatusToCheck && data) && (
            <>
              <BaseMessageBarInfo borderRadius={uiStyles.borderRadius} bgColor={'green.100'}>
                {confirmationMetadata?.message || 'We\'ve sent the receipt with your registration details to your email. It might take several minutes to arrive. Please also check your spam or junk folder.'}
              </BaseMessageBarInfo>
              <RegistrationDetails order={data.item} />
            </>
          )}
        </UiStack>
      </BaseTransitionSlideLeft>
      <UiStack height={96} />
    </RegisterLayout>
  );
};

export default ConfirmationPage;
